
export default {
  props: {
    crumbs: {
      type: Array,
      required: true
    }
  },
  computed: {
    jsonld () {
      return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: this.items
      }
    },
    structuredData () {
      return JSON.stringify(this.jsonld)
    },
    items () {
      return this.crumbs.map((crumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': this.$config.frontendHost + crumb.url,
          name: crumb.title
        }
      }))
    }
  }
}
